import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconSkipNext = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M10 17L17 12L10 7L10 17ZM7 17L9 17L9 7L7 7L7 17Z", clipRule: "evenodd" }) }));
const Memo = memo(SvgIconSkipNext);
export default Memo;
//# sourceMappingURL=IconSkipNext.js.map